export default {"src":"/_next/static/media/hero_right.ee7bf625.svg","height":99,"width":34,"blurWidth":0,"blurHeight":0};